<template>
    <div>

        <!-- Modal de Lançamento -->
        <div class="modal fade" id="lancamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="carregado">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <div v-if="!item || !item.id_lancamento">
                            Lançamento
                            <span class="badge badge-secondary ml-3" v-if="item && item.id_vale">VALE: {{ item.id_vale }}</span>
                            <span class="badge badge-warning ml-3" v-if="item && item.id_lancamento_origem">Reprogramar: #{{ item.id_lancamento_origem }}</span>
                        </div>
                        <div v-else>
                            Lançamento: {{ item.ch_tipo_lancamento == 'M' ? 'Adiantamento' :  ( item.ch_tipo_lancamento == 'D' ? 'Saída' : ( item.ch_tipo_lancamento == 'T' ? 'Transferência' : 'Entrada' ) ) }}
                            <span class="badge badge-secondary ml-3" v-if="item.id_lancamento">#{{ item.id_lancamento }}</span>
                            <span class="badge badge-secondary ml-3" v-if="item.id_vale">VALE: {{ item.id_vale }}</span>
                            <small class="text-muted ml-3" v-if="item.st_id_externo">{{ item.st_id_externo }}</small>
                            <span v-if="item.usuario" class="small text-muted ml-3">
                                Criado por: {{ item.usuario.st_login }}
                                <span v-if="item.created_at">
                                    em {{ $util.getFormatDate(item.created_at) }} {{ item.created_at.slice(11,16) }}
                                </span>
                            </span>
                        </div>                       
                    </h5>
                    <button type="button" class="close" @click="fechar()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="!item">
                        <az-empty-state />
                    </div>

                    <div v-else-if="item">

                        <!-- Reprogramação -->

                        <div class="alert alert-warning" v-if="item.ch_estado == 'R'">
                            <strong>Reprogramado</strong>
                            <ul v-if="item.reprogramados && item.reprogramados.length" class="mb-0">
                                <li v-for="(reprogramado, irx) in item.reprogramados" :key="irx">
                                    <a href="#" @click.prevent="editar({ id_lancamento: reprogramado.id_lancamento })" class="card-link">
                                        #{{ reprogramado.id_lancamento }}, {{ $util.getFormatDate(reprogramado.dt_vencimento) }} = {{ $util.formatMoeda(reprogramado.dc_valor) }}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="alert alert-warning" v-if="item.origem">
                            <strong>Origem</strong>
                            <ul class="mb-0">
                                <li>
                                    <a href="#" @click.prevent="editar({ id_lancamento: item.id_lancamento_origem })" class="card-link">
                                        #{{ item.origem.id_lancamento }}, {{ $util.getFormatDate(item.origem.dt_vencimento) }} = {{ $util.formatMoeda(item.origem.dc_valor) }}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <!-- Lançamento -->

                        <template v-if="!item.id_lancamento && !item.id_lancamento_origem">
                            <az-input
                                sizing="sm"
                                class="mb-3"
                                type="button-group"
                                :optionsList="lista_opcoes_lancamento" 
                                optionsData="id"
                                optionsDisplay="Search"
                                :edicao="!item.gerar_imposto && !item.id_estoque_nota_fiscal && !item.id_vale && !item.id_reembolso && !item.id_conta_destino"
                                v-model="item.ch_tipo_lancamento" 
                                @input="refresh_impostos()" />
                        </template>

                        <template v-else-if="item.ch_estado == 'C'">
                            <div class="alert alert-danger">
                                <strong>
                                    <i class="fas fa-exclamation-triangle text-danger mr-2"></i>
                                    Lançamento cancelado.
                                </strong>
                                <div v-if="item.st_motivo_cancela">
                                    Motivo: {{ item.st_motivo_cancela }}
                                </div>
                                <div v-if="item.usuario_cancela">
                                    Responsável: {{ item.usuario_cancela.st_login }}
                                </div>
                            </div>
                        </template>

                        <!-- Vinculo UneCont -->

                        <div v-if="item && item.nf_externa">
                            <div class="alert alert-info d-flex justify-content-between">
                                <div>
                                    <div>
                                        <i class="fa-solid fa-file-invoice-dollar fa-fw mr-2"></i>
                                        Nota Fiscal Identificada: <strong class="ml-1">{{ item.nf_externa.st_numero_nf }}</strong>
                                    </div>
                                    <div>
                                        <i class="fa-regular fa-calendar fa-fw mr-2"></i>
                                        Emissão: <strong class="ml-1">{{ $util.getFormatDate(item.nf_externa.dt_emissao) }}</strong>
                                    </div>
                                    <div>
                                        <i class="fa-solid fa-equals fa-fw mr-2"></i>
                                        Valor: <strong class="ml-1">{{ $util.formatMoeda(item.nf_externa.dc_valor_bruto) }}</strong>
                                    </div>
                                    <div class="row">
                                        <div class="col col-12 text-truncate">
                                            <i class="fa-solid fa-comment fa-fw mr-3"></i>
                                            <span class="small text-muted">{{ item.st_descricao }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="!item.baixa">
                                    <a href="#" @click.prevent="item.id_nota_fiscal_externa = null; item.nf_externa = null;" class="card-link">
                                        <i class="fa-solid fa-xmark text-danger"></i>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!-- Entrada e Saída -->

                        <div v-if="item.ch_tipo_lancamento != 'T' && item.ch_tipo_lancamento != 'M'">

                            <div class="form-row">
                                <div class="col col-12" :class="( item.ch_tipo_lancamento == 'M' || item.distribuir || item.id_estoque_nota_fiscal ) ? 'col-md-6' : 'col-md-3'" v-if="$store.state.unidade.unidade_operacaos.length > 1">
                                    <az-input
                                        sizing="sm"
                                        label="Unidade"
                                        type="select"
                                        placeholder="Selecione..."
                                        :optionsList="$store.state.unidade.unidade_operacaos"
                                        optionsData="id_unidade_operacao"
                                        :required="!unidade && !item.baixa"
                                        :validate="validate"
                                        :edicao="( !unidade || isNaN(unidade) ) && !item.baixa && pode_atualizar_partic && !item.id_vale && !item.nf_externa"
                                        v-model="item.id_unidade_operacao" />
                                </div>
                                <div class="col col-12 col-md-3" v-if="( lista_centros.length > 1 || centros_livres ) && item.ch_tipo_lancamento != 'M' && !item.distribuir && ( !item.id_estoque_nota_fiscal || item.id_centro_custo )">
                                    <!-- :required="!unidade && !item.baixa && item.ch_tipo_lancamento == 'D'" -->
                                    <az-input
                                        sizing="sm"
                                        label="Centro de Custo"
                                        type="select"
                                        placeholder="Selecione..."
                                        :optionsList="lista_centros"
                                        optionsData="id_centro_custo"
                                        required2="!item.baixa && pode_atualizar_partic"
                                        :validate="validate"
                                        :edicao="!item.baixa && pode_atualizar_partic && !item.id_estoque_nota_fiscal"
                                        v-model="item.id_centro_custo">
                                        <template v-slot:buttonposb v-if="!item.baixa && pode_atualizar_partic && !item.id_estoque_nota_fiscal"> <!-- v-if="!item.id_lancamento"> -->
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                                    data-toggle="tooltip" data-placement="top" title="Distribuir valor." @click="distribuir()">
                                                    <i class="fas fa-list"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12" :class="$store.state.unidade.unidade_operacaos.length > 1 ? 'col-md-6' 
                                        : ( ( lista_centros.length > 1 && !item.distribuir ) ? 'col-md-9' : '' ) ">
                                    <az-input
                                        sizing="sm"
                                        label="Histórico"
                                        required 
                                        :edicao="pode_atualizar_partic"
                                        :validate="validate"
                                        v-model="item.st_descricao" />
                                </div>
                            </div>

                            <template v-if="!item.id_lancamento && !item.recorrente && !item.id_lancamento_origem">
                                <div class="form-row" key="tipo_lanc">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            label="Lançamento"
                                            placeholder="Previsto"
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="lista_tipo_lanc"
                                            optionsData="id" 
                                            :edicao="!fechamento && !item.id_vale"
                                            v-model="item.tipo_lanc" />
                                    </div>
                                    <div class="col col-12 col-md-6" v-if="item.tipo_lanc == 'R'">
                                        <az-input
                                            sizing="sm"
                                            label="Conta"
                                            :validate="validate"
                                            type="select"
                                            optionsMode="aql"
                                            service="contas.index"
                                            optionsName="contas.index.ativas"
                                            optionsData="id_conta"
                                            optionsDisplay="search"
                                            :optionsParm="{ ativas: true }"
                                            required
                                            :edicao="!fechamento && !item.id_vale"
                                            v-model="item.id_conta_baixa" />
                                    </div>
                                </div>
                            </template>

                            <div class="form-row">
                                <div class="col col-12 col-md-6" key="categoria">
                                    <template v-if="!item.distribuir_categ">
                                        <template v-if="!pode_atualizar_partic">
                                            <az-input
                                                label="Categoria"
                                                :edicao="false"
                                                :value="( item.categoria && item.categoria.search ) ? item.categoria.search : item.id_categoria" />
                                        </template>
                                        <template v-else-if="tipo_lista_categoria == 'L'">
                                            <az-input
                                                v-if="item.ch_tipo_lancamento != 'M'"
                                                sizing="sm"
                                                label="Categoria"
                                                required
                                                :validate="validate"
                                                type="select"
                                                optionsMode="aql"
                                                :edicao="pode_atualizar_partic"
                                                service="categorias.index"
                                                :optionsName="'categorias.' + ( item ? item.ch_tipo_lancamento : 'X' )"
                                                optionsData="id_categoria"
                                                optionsDisplay="search"
                                                :optionsParm="{ lancamento: true, where: { ch_natureza: item ? item.ch_tipo_lancamento : '?' } }"
                                                v-model="item.id_categoria">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="alterar_tipo_lista()">
                                                            <i class="fa fa-search" aria-hidden="true"></i>
                                                        </button>
                                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Distribuir valor em várias categorias" @click="distribuir_categ()">
                                                            <i class="fas fa-list"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </template>
                                        <template v-else>
                                            <az-input
                                                v-if="item.ch_tipo_lancamento != 'M'"
                                                sizing="sm"
                                                label="Categoria"
                                                required
                                                :validate="validate"
                                                type="autocomplete"
                                                optionsMode="aql"
                                                :edicao="pode_atualizar_partic"
                                                service="categorias.index"
                                                :optionsName="'categorias.' + ( item ? item.ch_tipo_lancamento : 'X' )"
                                                optionsData="id_categoria"
                                                optionsDisplay="search"
                                                :optionsParm="{ lancamento: true, natureza: ( item ? item.ch_tipo_lancamento : '?' ) }"
                                                v-model="item.id_categoria">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="alterar_tipo_lista()">
                                                            <i class="fas fa-caret-square-down"></i>
                                                        </button>
                                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Distribuir valor em várias categorias" @click="distribuir_categ()">
                                                            <i class="fas fa-list"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </template>
                                    </template>
                                    <!-- FIM CATEGORIA -->
                                    
                                </div>
                                <div class="col col-12 col-md-6" v-if="!item.gerar_imposto && pode_atualizar_partic">
                                    <az-input
                                        :key="'cliente'"
                                        sizing="sm"
                                        label="Cliente"
                                        type="select" 
                                        optionsMode="aql"
                                        optionsData="id_operadora"
                                        optionsDisplay="st_operadora"
                                        :optionsParms="{ fatura: true }"
                                        service="operadoras.index"
                                        optionsName="operadoras-para-fatura"
                                        placeholder="Não informado."
                                        v-model="item.id_operadora"
                                        :edicao="!item.nf_externa"
                                        v-if="item.ch_tipo_lancamento == 'C' && !item.id_fornecedor && item.sel_form != 'F'">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="item.sel_form">
                                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="item.sel_form = 'F'; item.id_operadora = null;">
                                                    F
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>

                                    <template v-else>
                                        <az-input
                                            :key="'fornecedor'"
                                            sizing="sm"
                                            label="Fornecedor"
                                            :validate="validate"
                                            type="autocomplete" 
                                            optionsMode="aql"
                                            service="fornecedores.index"
                                            ToptionsData="id_fornecedor"
                                            optionsDisplay="search"
                                            :optionsParm="{ ativas: true, tipo_lanc: ( !item.id_lancamento ? 'A' : '' ) }"
                                            :required="item.ch_tipo_lancamento == 'M'"
                                            :edicao="!item.nf_externa"
                                            v-model="item.fornecedor"
                                            @input="incluir_impostos()">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="!blockaddfornecedor">
                                                    <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                                        data-toggle="tooltip" data-placement="top" title="Incluir Fornecedor"
                                                        @click="incluir_fornecedor()">
                                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </template>
                                        <!-- item.tipo_lanc -->
                                </div>
                            </div>

                            <!-- item.tipo_lanc == 'A' &&  -->
                            <saldo-adiantamento 
                                :fornecedor="item.fornecedor" 
                                :valor="item.dc_valor_uso_adiantamento" 
                                :edicao="!item.id_lancamento || item.pode_adiantar"
                                v-if="item && item.fornecedor && !item.recorrente" 
                                @usar="utilizar_ad" />

                            <div class="form-row">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        type="money"
                                        label="Valor"
                                        required 
                                        :validate="validate"
                                        :edicao="!item.baixa && pode_atualizar_partic && !tem_valor_parcela"
                                        v-model="item.dc_valor"
                                        @input="recalcular_impostos()" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        v-if="item.ch_tipo_lancamento == 'D'"
                                        sizing="sm"
                                        type="money"
                                        label="Multa/Juros"
                                        :validate="validate"
                                        :edicao="!item.baixa && pode_atualizar_partic && !tem_valor_parcela"
                                        v-model="item.dc_multa_juros" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        v-if="item.ch_tipo_lancamento == 'D'"
                                        sizing="sm"
                                        type="money"
                                        label="Desconto"
                                        :validate="validate"
                                        :edicao="!item.baixa && pode_atualizar_partic && !tem_valor_parcela"
                                        v-model="item.dc_descontos" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        type="month"
                                        required 
                                        :validate="validate"
                                        :edicao="!fechamento && ( !item.baixa || item.pode_alterar_compet_baixado ) && pode_atualizar_partic"
                                        v-model="item.dt_competencia"
                                        label="Competência">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="!item.id_lancamento && item.recorrente && item.quantidade > 1">
                                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="item.competencia_fixa = !item.competencia_fixa">
                                                    <i class="fas fa-ellipsis-h" v-if="!item.competencia_fixa" title="Competência Flutuante"></i>
                                                    <i class="fas fa-thumbtack" v-else title="Competência Fixa"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Forma de Pagamento"
                                        :validate="validate"
                                        type="select"
                                        optionsMode="aql"
                                        service="forma_pagamentos.index"
                                        optionsData="id_forma_pagamento"
                                        optionsDisplay="search"
                                        :edicao="!item.baixa"
                                        v-model="item.id_forma_pagamento"
                                        @change="trocar_forma(item)" />
                                </div>
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Documento"
                                        :validate="validate"
                                        v-model="item.st_doc" />
                                </div>
                            </div>

                            <div class="form-row" v-if="!trocando_valor_ad && item.ch_tipo_lancamento == 'D' && ( item.dc_valor_uso_adiantamento || ( !item.baixa && saldo_adiantamentos > 0 ) ) && !item.recorrente">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        type="money"
                                        label="Valor Adiantado"
                                        :validate="validate"
                                        :edicao="!item.baixa && ( !item.id_lancamento || item.pode_adiantar ) && pode_atualizar_partic"
                                        v-if="!trocando_valor_ad && item.ch_tipo_lancamento == 'D' && ( item.dc_valor_uso_adiantamento || ( !item.baixa && saldo_adiantamentos > 0 ) ) && !item.recorrente"
                                        v-model="item.dc_valor_uso_adiantamento">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="item.dc_valor_uso_adiantamento && item.id_lancamento && !item.baixa">
                                                <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover_adiantamento()" title="Remover valor adiantado.">
                                                    <i class="fa-solid fa-xmark"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <div v-if="item.fornecedor && item.fornecedor.dc_valor_maximo && item.dc_valor > item.fornecedor.dc_valor_maximo" class="alert alert-warning">
                                <strong>
                                    <i class="fas fa-exclamation-triangle mr-2"></i>
                                    Valor do lançamento ultrapassa o valor máximo cadastrado para o fornecedor: 
                                    {{ $util.formatMoeda(item.fornecedor.dc_valor_maximo) }}
                                </strong>
                            </div>

                            <!-- Impostos -->
                            <impostos
                                ref="impostos" 
                                :impostos="lista_impostos" 
                                v-if="( item.ch_tipo_lancamento == 'D' || item.ch_tipo_lancamento == 'C' )
                                    && lista_impostos.length && !item.gerar_imposto" 
                                :edicao="!item.baixa" 
                                v-model="item" />

                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="date"
                                        label="Emissão"
                                        :validate="validate"
                                        required
                                        :edicao="!fechamento && ( !item.baixa || item.pode_alterar_compet_baixado ) && pode_atualizar_partic"
                                        v-model="item.dt_emissao">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="!item.id_lancamento && item.recorrente && item.quantidade > 1">
                                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="item.recorrente_emissao_fixa = !item.recorrente_emissao_fixa">
                                                    <i class="fas fa-ellipsis-h" v-if="!item.recorrente_emissao_fixa" title="Competência Flutuante"></i>
                                                    <i class="fas fa-thumbtack" v-else title="Competência Fixa"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        type="date"
                                        label="Vencimento"
                                        required
                                        :validate="validate"
                                        :edicao="!fechamento && !item.baixa && !tem_valor_parcela"
                                        v-model="item.dt_vencimento" />
                                </div>

                                <!-- REALIZADO ou RECORRENTE -->
                                <template v-if="!item.id_lancamento && item.tipo_lanc == 'R'">
                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            type="money"
                                            label="Descontos/Taxas"
                                            v-model="item.desconto" />
                                    </div>

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            sizing="sm"
                                            type="money"
                                            label="Multas/Juros"
                                            v-model="item.multa" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <small class="form-text text-muted text-nowrap text-truncate">
                                            Líquido
                                        </small>
                                        <div class="input-group input-group-sm">
                                            <label class="form form-control">
                                                {{ $util.formatMoeda(liquido) }}
                                            </label>
                                        </div>
                                    </div>
                                </template>

                                <div class="col col-12 col-md-3" v-if="item.id_lancamento || !item.recorrente">
                                    <az-input
                                        sizing="sm"
                                        type="date"
                                        label="Pagamento"
                                        :validate="validate"
                                        :edicao="!fechamento && !item.baixa && !tem_valor_parcela"
                                        v-model="item.dt_pagamento" />
                                </div>

                                <template v-if="!item.id_lancamento && !item.dc_valor_uso_adiantamento && item.tipo_lanc != 'R' && item.tipo_lanc != 'A' && !item.gerar_imposto && item.ch_tipo_lancamento != 'M' && !item.id_reembolso">
                                    <div class="col col-12 col-md-1">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox"
                                            label="Recorrente"
                                            v-model="item.recorrente"
                                            @click="item.dt_pagamento = null" />
                                    </div>
                                    <div class="col col-12 col-md-2" v-if="item.recorrente">
                                        <az-input
                                            sizing="sm"
                                            type="number"
                                            label="Quantidade"
                                            required
                                            :edicao="!item.vencs"
                                            v-model="item.quantidade">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="definir_vencimentos(item)">
                                                        <i class="far fa-calendar-check"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-3" v-if="item.recorrente && item.vencs">
                                        <az-input 
                                            sizing="sm"
                                            type="button-group"
                                            label="Valor informado é..."
                                            :optionsList="[
                                                { id: 'P', search: 'Parcela' },
                                                { id: 'T', search: 'Total' },
                                            ]"
                                            v-model="item.tipo_valor"
                                            @click="recalc_parcelas(item)">
                                        </az-input>
                                    </div>

                                    <template v-if="item.vencs && item.recorrente && item.tipo_valor == 'P'">
                                        <div class="col col-12 col-md-3" v-for="parc in (item.quantidade - 1)" :key="parc">
                                            <az-input
                                                v-if="item.vencimentos[parc]"
                                                sizing="sm"
                                                type="date"
                                                required
                                                v-model="item.vencimentos[parc].data">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon1">
                                                            Venc. {{ parc + 1 }}
                                                        </span>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </template>
                                </template>

                                <template v-else-if="item.id_recorrencia && item.recorrencia.in_quantidade > 1">
                                    <div class="col col-12 col-md-3 align-bottom">
                                        <div class="form-group">
                                            <small class="form-text text-muted text-nowrap text-truncate">
                                                {{ item.recorrencia.in_quantidade }} parcelas
                                                <span class="ml-3">
                                                    {{ item.in_parcela }}/{{ item.in_total_parcelas }}
                                                </span>
                                            </small>
                                            <a href="#" @click.prevent="carregar_recorrencia (item.id_recorrencia)">
                                                <i class="fas fa-sync-alt"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col col-12 col-md-3" v-if="!item.baixa">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox"
                                            label="Ajustar Demais Parcelas"
                                            v-model="item.ajustar_recorrencia" />
                                    </div>
                                </template>
                            </div>

                            <div class="form-row" v-if="item.item_pagamento_atendimento && ( item.id_forma_pagamento == 2 || item.id_forma_pagamento == 3 )">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        v-if="item.id_forma_pagamento == 2"
                                        sizing="sm"
                                        id="credito"
                                        label="Bandeira do Cartão de Crédito"
                                        placeholder="Selecione a Bandeira..."
                                        type="select"
                                        optionsMode="aql"
                                        service="bandeira_cartaos.index"
                                        optionsData="id_bandeira_cartao"
                                        optionsDisplay="search"
                                        :optionsName="'band_card.cre.index.'+ item.id_unidade_operacao"
                                        :optionsParm="{
                                            where: { ch_tipo: 'C' },
                                            id_unidade_operacao: item.id_unidade_operacao
                                        }"
                                        @change.native="false"
                                        icon="fas fa-credit-card fa-fw"
                                        v-model="item.item_pagamento_atendimento.id_bandeira_cartao"
                                        required
                                        :validate="validate"
                                        :edicao="!fechamento && !item.baixa" />

                                    <az-input
                                        v-if="item.id_forma_pagamento == 3"
                                        sizing="sm"
                                        id="debito"
                                        label="Bandeira do Cartão de Débito"
                                        placeholder="Selecione a Bandeira..."
                                        type="select"
                                        optionsMode="aql"
                                        service="bandeira_cartaos.index"
                                        optionsData="id_bandeira_cartao"
                                        optionsDisplay="search"
                                        :optionsName="'band_card.deb.index.'+ item.id_unidade_operacao"
                                        :optionsParm="{
                                            where: { ch_tipo: 'D' },
                                            id_unidade_operacao: item.id_unidade_operacao
                                        }"
                                        @change.native="false"
                                        icon="fas fa-credit-card fa-fw"
                                        v-model="item.item_pagamento_atendimento.id_bandeira_cartao"
                                        required
                                        :validate="validate"
                                        :edicao="!fechamento && !item.baixa" />
                                </div>
                            </div>

                            <!-- Detalhe das Parcelas -->
                            <template v-if="item.vencs && item.recorrente && item.tipo_valor == 'T'">
                                <div class="form-row" v-for="(parcela, ipx) in item.vencimentos" :key="ipx">
                                    <template v-if="parcela">
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                :label="!ipx ? 'Vencimento' : ''"
                                                sizing="sm"
                                                type="date"
                                                required
                                                v-model="parcela.data">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon1">{{ ipx + 1 }}</span>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                :label="!ipx ? 'Valor' : ''"
                                                sizing="sm"
                                                type="money"
                                                required
                                                v-model="parcela.valor">
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-6" v-if="false">
                                            <impostos
                                                :parcelas="true"
                                                :ref="'impostos_' + ipx" 
                                                :impostos="lista_impostos" 
                                                v-if="( item.ch_tipo_lancamento == 'D' || item.ch_tipo_lancamento == 'C' ) && lista_impostos.length && !item.gerar_imposto" 
                                                :edicao="!item.baixa" 
                                                v-model="parcela.impostos" />
                                        </div>
                                    </template>
                                </div>

                                <div class="small" :class="total_parcelas != item.dc_valor ? 'text-danger' : 'text-muted'">
                                    Total: {{ $util.formatMoeda(total_parcelas) }}
                                </div>
                            </template>

                            <!-- @CENTROS DE CUSTO - Distribuição --> 
                            <template v-if="item.distribuir || item.distribuir_categ">
                                <div class="mb-3">
                                    <az-sub-title :title="titulo_distribuir()" class="mt-2">
                                        <span class="mr-5">
                                            Total: {{ $util.formatMoeda(total_centros) }}
                                            <i class="fa fa-check-circle text-success ml-1" aria-hidden="true" v-if="Math.round(total_centros * 100) == Math.round(item.dc_valor * 100)"></i>
                                            <span v-else>
                                                <span v-if="item.dc_valor > total_centros" class="text-muted ml-1">
                                                    ({{ $util.formatMoeda(item.dc_valor - total_centros) }})
                                                </span>
                                                <i class="fa fa-times-circle text-danger ml-1" aria-hidden="true"></i>
                                            </span>
                                        </span>

                                        <a href="#" class="card-link" @click.prevent="incluir_centro()">
                                            <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                            Incluir
                                        </a>

                                        <a href="#" class="card-link ml-3" @click.prevent="cancelar_distribuir()" v-if="!item.id_lancamento" title="Cancelar distribuição.">
                                            <i class="fa fa-times text-danger" aria-hidden="true"></i>
                                        </a>
                                    </az-sub-title>
                                    <div class="form-row" v-for="(centro, icx) in lista_centros_dist" :key="icx">
                                        <div class="col col-12" :class="item.distribuir_categ ? 'col-md-3' : 'col-md-6'" v-if="item.distribuir">
                                            <az-input
                                                v-if="centro.centro_custo"
                                                sizing="sm"
                                                placeholder="Centro de Custo..."
                                                :edicao="false"
                                                v-model="centro.centro_custo.search">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover_centro(centro)">
                                                            <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>

                                            <az-input
                                                v-else
                                                sizing="sm"
                                                type="select"
                                                placeholder="Selecione o Centro de Custo..."
                                                :optionsList="lista_centros"
                                                optionsData="id_centro_custo"
                                                required
                                                :validate="validate"
                                                :edicao="!item.baixa"
                                                v-model="centro.id_centro_custo">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover_centro(centro)">
                                                            <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>

                                        <!-- Seleção da Categoria Distribuida -->
                                        <div class="col col-12" :class="item.distribuir ? 'col-md-3' : 'col-md-6'" v-if="item.distribuir_categ">
                                            <template v-if="!centro.busca_lista">
                                                <az-input
                                                    sizing="sm"
                                                    placeholder="Selecione a Categoria..."
                                                    required
                                                    :validate="validate"
                                                    type="select"
                                                    optionsMode="aql"
                                                    :edicao="pode_atualizar_partic"
                                                    service="categorias.index"
                                                    :optionsName="'categorias.' + ( item ? item.ch_tipo_lancamento : 'X' )"
                                                    optionsData="id_categoria"
                                                    optionsDisplay="search"
                                                    :optionsParm="{ lancamento: true, where: { ch_natureza: item ? item.ch_tipo_lancamento : '?' } }"
                                                    v-model="centro.id_categoria">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend" v-if="!item.distribuir">
                                                            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover_centro(centro)">
                                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>

                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append" v-if="!item.distribuir && !centro.id_lancamento_centro_custo && pode_atualizar_partic">
                                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="alterar_tipo_lista_item(centro)">
                                                                <i class="fa fa-search fa-fw" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>                
                                            </template>
                                            
                                            <template v-else>
                                                <az-input
                                                    sizing="sm"
                                                    placeholder="Selecione a Categoria..."
                                                    required
                                                    :validate="validate"
                                                    type="autocomplete"
                                                    optionsMode="aql"
                                                    :edicao="pode_atualizar_partic"
                                                    service="categorias.index"
                                                    :optionsName="'categorias.' + ( item ? item.ch_tipo_lancamento : 'X' )"
                                                    optionsData="id_categoria"
                                                    optionsDisplay="search"
                                                    :optionsParm="{ lancamento: true, natureza: ( item ? item.ch_tipo_lancamento : '?' ) }"
                                                    v-model="centro.id_categoria">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend" v-if="!item.distribuir">
                                                            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover_centro(centro)">
                                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>

                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append" v-if="!item.distribuir && !centro.id_lancamento_centro_custo && pode_atualizar_partic">
                                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="alterar_tipo_lista_item(centro)">
                                                                <i class="fas fa-caret-square-down fa-fw"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </template>
                                        </div>
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                v-if="!centro.dc_percentual"
                                                sizing="sm"
                                                icon="fas fa-dollar-sign"
                                                :type="movendo_centro ? 'text' : 'money'"
                                                required
                                                :edicao="!item.baixa"
                                                v-model="centro.dc_valor" />

                                            <div class="input-group input-group-sm" v-else>
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">
                                                        <i class="fas fa-dollar-sign" aria-hidden="true"></i>
                                                    </span>
                                                </div>
                                                <label class="form form-control text-muted" disabled>
                                                    {{ $util.formatMoeda( Math.round(centro.dc_percentual * item.dc_valor) / 100 ) }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                v-if="!centro.dc_valor"
                                                icon="fas fa-percent"
                                                sizing="sm"
                                                :type="movendo_centro ? 'text' : 'money'"
                                                required
                                                :edicao="!item.baixa"
                                                v-model="centro.dc_percentual" />

                                            <div class="input-group input-group-sm" v-else-if="item.dc_valor > 0">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="basic-addon1">
                                                        <i class="fa fa-percent" aria-hidden="true"></i>
                                                    </span>
                                                </div>
                                                <label class="form form-control text-muted" disabled>
                                                    {{ $util.formatMoeda( Math.round( ( centro.dc_valor / item.dc_valor ) * 10000 ) / 100 ) }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="item.distribuir && lista_centros_dist.length <= 1" class="form-row">
                                        <div class="col col-12">
                                            <az-input   
                                                icon="fa fa-plus fa-fw"
                                                placeholder="Modelo de Distribução..."
                                                sizing="sm"
                                                type="autocomplete"
                                                service="modelo_dists.index"
                                                v-model="modelo_dist"
                                                @input="aplicar_modelo()" />
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="item.lanc_credito_vincs && item.lanc_credito_vincs.length">
                                <az-sub-title class="mt-3" title="Créditos Identificados" />
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between p-2" v-for="(lanc_credito, ifcx) in item.lanc_credito_vincs" :key="ifcx">
                                        <div>
                                            Crédito: #{{ lanc_credito.id_lancamento_baixa }}
                                        </div>
                                        <div class="text-right">
                                            {{ $util.formatMoeda(lanc_credito.dc_valor) }}
                                            <div class="small text-muted" v-if="lanc_credito.dc_retencoes">
                                                {{ $util.formatMoeda(lanc_credito.dc_retencoes) }}
                                            </div>
                                        </div>
                                    </li>

                                    <li class="list-group-item list-group-item-secondary p-2 d-flex justify-content-between">
                                        <div>
                                            <span class="small">Total</span>
                                        </div>
                                        <div>
                                            {{ $util.formatMoeda(totalizar(item.lanc_credito_vincs, 'dc_valor')) }}
                                        </div>
                                    </li>

                                    <li class="list-group-item list-group-item-secondary p-2 d-flex justify-content-between">
                                        <div>
                                            <span class="small">Saldo</span>
                                        </div>
                                        <div>
                                            {{ $util.formatMoeda(item.liquido) }}
                                        </div>
                                    </li>
                                </ul>
                            </template>

                            <template v-if="item.baixa">
                                <az-sub-title class="mt-3" :title="( item.baixas && item.baixas.length > 1 ) ? 'Baixas Realizadas' : 'Baixa Realizada'">
                                    <span v-if="item.baixado.saldo > 0">
                                        Saldo: {{ $util.formatMoeda(item.baixado.saldo) }}
                                    </span>
                                </az-sub-title>
                                <div v-for="(bxp, ibx) in item.baixas" :key="ibx">
                                    <div class="form-row">
                                        <div class="col col-12 col-md-3">
                                            <az-input
                                                sizing="sm"
                                                :buttonIcon="true"
                                                icon="fas fa-search-dollar"
                                                buttonColor="outline-secondary"
                                                buttonText="fas fa-search-dollar"
                                                :label="ibx ? '' : 'Data da Baixa'"
                                                type="date"
                                                :edicao="false"
                                                v-model="bxp.dt_baixa" 
                                                @clickButton="registrar_baixa (item, bxp)" />
                                        </div>
                                        <div class="col col-12 col-md-5">
                                            <az-input
                                                sizing="sm"
                                                :label="ibx ? '' : 'Observações'"
                                                :edicao="false"
                                                v-model="bxp.st_observacoes" />
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <small v-if="!ibx" class="form-text text-muted text-nowrap text-truncate">
                                                Valor
                                            </small>
                                            <div class="input-group input-group-sm">
                                                <label class="form form-control" disabled>
                                                    {{ $util.formatMoeda(bxp.dc_valor) }}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <small v-if="!ibx" class="form-text text-muted text-nowrap text-truncate">
                                                Líquido
                                            </small>
                                            <div class="input-group input-group-sm">
                                                <label class="form form-control" disabled>
                                                    {{ $util.formatMoeda(bxp.valor_liquido) }}
                                                </label>
                                                <div class="input-group-append" v-if="bxp.fl_conciliado">
                                                    <span class="input-group-text" id="basic-addon2" title="Conciliado.">
                                                        <i class="fa-solid fa-circle-check text-success"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="alert alert-success" v-if="bxp.fl_conciliado">
                                        <div class="d-flex justify-content-between">
                                            <div>
                                                <i class="fa fa-check mr-3" aria-hidden="true"></i>
                                                Conciliado
                                            </div>
                                            <div>
                                                {{ $util.getFormatDate(bxp.dt_conciliacao) }}
                                            </div>
                                        </div>

                                        <div v-if="bxp.st_memo_extrato" class="small text-muted">
                                            {{ bxp.st_memo_extrato }}
                                        </div>

                                        <div class="small text-muted" v-if="bxp.st_conciliacao_fitid || bxp.st_conciliacao_checknum">
                                            Conciliação: {{ bxp.st_conciliacao_fitid }} / {{ bxp.st_conciliacao_checknum }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Uso do Crédito em Faturas -->
                                <template v-if="item.baixa.fatura_creditos && item.baixa.fatura_creditos.length">
                                    <az-sub-title class="mt-3" title="Uso do Crédito / Faturas" />
                                    <ul class="list-group">
                                        <li class="list-group-item d-flex justify-content-between p-2" v-for="(fatura_credito, ifcx) in item.baixa.fatura_creditos" :key="ifcx">
                                            <div>
                                                Fatura: #{{ fatura_credito.id_fatura }}
                                                <span class="small text-muted ml-3">
                                                    em {{ $util.getFormatDate(fatura_credito.dt_recebimento) }}
                                                </span>
                                            </div>
                                            <div>
                                                {{ $util.formatMoeda(fatura_credito.dc_valor) }}
                                            </div>
                                        </li>

                                        <li class="list-group-item list-group-item-secondary p-2 d-flex justify-content-between">
                                            <div>
                                                <span class="small">Total</span>
                                            </div>
                                            <div>
                                                {{ $util.formatMoeda(totalizar(item.baixa.fatura_creditos, 'dc_valor')) }}
                                            </div>
                                        </li>

                                        <li class="list-group-item list-group-item-secondary p-2 d-flex justify-content-between">
                                            <div>
                                                <span class="small">Saldo</span>
                                            </div>
                                            <div>
                                                {{ $util.formatMoeda(item.baixa.valor_liquido - totalizar(item.baixa.fatura_creditos, 'dc_valor')) }}
                                            </div>
                                        </li>
                                    </ul>
                                </template>

                                <!-- Uso de Crédito em Lançametos -->
                                <template v-if="item.lanc_credito_usos && item.lanc_credito_usos.length">
                                    <az-sub-title class="mt-3" title="Uso do Crédito / Lançamentos" />
                                    <ul class="list-group">
                                        <li class="list-group-item d-flex justify-content-between p-2" v-for="(lanc_fatura, ifcx) in item.lanc_credito_usos" :key="ifcx">
                                            <div>
                                                Lanc: #{{ lanc_fatura.id_lancamento_fatura }}
                                            </div>
                                            <div>
                                                {{ $util.formatMoeda(lanc_fatura.dc_valor) }}
                                            </div>
                                        </li>

                                        <li class="list-group-item list-group-item-secondary p-2 d-flex justify-content-between">
                                            <div>
                                                <span class="small">Total</span>
                                            </div>
                                            <div>
                                                {{ $util.formatMoeda(totalizar(item.lanc_credito_usos, 'dc_valor')) }}
                                            </div>
                                        </li>

                                        <li class="list-group-item list-group-item-secondary p-2 d-flex justify-content-between">
                                            <div>
                                                <span class="small">Saldo</span>
                                            </div>
                                            <div>
                                                {{ $util.formatMoeda(item.baixa.valor_liquido - totalizar(item.lanc_credito_usos, 'dc_valor')) }}
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                            </template>

                        </div>

                        <!-- Transferência -->

                        <template v-if="item.ch_tipo_lancamento == 'T' || item.ch_tipo_lancamento == 'M'">

                            <div class="row">
                                <div class="col">
                                    <az-input
                                        sizing="sm"
                                        label="Descrição"
                                        required 
                                        :validate="validate"
                                        v-model="item.st_descricao" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <az-input
                                        sizing="sm"
                                        label="Fornecedor"
                                        :validate="validate"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="fornecedores.index"
                                        ToptionsData="id_fornecedor"
                                        optionsDisplay="search"
                                        :edicao="!item.id_lancamento"
                                        :required="item.ch_tipo_lancamento == 'M'"
                                        v-model="item.fornecedor" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <selecao-categoria
                                        :validate="validate"
                                        :block_required="true"
                                        ch_tipo_lancamento="T"
                                        v-model="item.id_categoria" />
                                </div>
                            </div>

                            <!--  && $store.state.user.id_usuario == 1 -->
                            <div class="row mt-2" v-if="item.ch_tipo_lancamento == 'M' && !item.id_lancamento_origem && !item.id_lancamento">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        label="Previsto"
                                        :validate="validate"
                                        type="checkbox-group"
                                        v-model="item.ad_previsto" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6" v-if="!item.ad_previsto">
                                    <az-input
                                        sizing="sm"
                                        label="Conta de Origem"
                                        :validate="validate"
                                        type="select"
                                        optionsMode="aql"
                                        service="contas.index"
                                        optionsName="contas.index.ativas"
                                        optionsData="id_conta"
                                        optionsDisplay="search"
                                        :optionsParm="{ ativas: true }"
                                        :edicao="!item.id_lancamento"
                                        required
                                        v-model="item.id_conta_origem" />
                                </div>

                                <template v-if="item.ch_tipo_lancamento == 'M' && item.ad_previsto">
                                    <div class="col col-12 col-md-6" v-if="$store.state.unidade.unidade_operacaos.length > 1">
                                        <az-input
                                            sizing="sm"
                                            label="Unidade"
                                            type="select"
                                            placeholder="Selecione..."
                                            :optionsList="$store.state.unidade.unidade_operacaos"
                                            optionsData="id_unidade_operacao"
                                            :required="!item.baixa"
                                            :validate="validate"
                                            :edicao="!item.baixa"
                                            v-model="item.id_unidade_operacao" />
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            label="Vencimento"
                                            required
                                            :validate="validate"
                                            type="date"
                                            v-model="item.dt_vencimento" />
                                    </div>
                                </template>

                                <div class="col col-12 col-md-6" v-if="item.ch_tipo_lancamento != 'M'">
                                    <az-input
                                        sizing="sm"
                                        label="Conta de Destino"
                                        :validate="validate"
                                        type="select"
                                        optionsMode="aql"
                                        service="contas.index"
                                        optionsName="contas.index.ativas"
                                        optionsData="id_conta"
                                        optionsDisplay="search"
                                        :optionsParm="{ ativas: true }"
                                        required
                                        v-model="item.id_conta_destino" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="money"
                                        label="Valor"
                                        required 
                                        :validate="validate"
                                        :edicao="!item.id_lancamento"
                                        v-model="item.dc_valor" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        sizing="sm"
                                        type="date"
                                        label="Data"
                                        :validate="validate"
                                        v-model="item.dt_emissao" />
                                </div>
                            </div>

                            <saldo-adiantamento 
                                :fornecedor="item.fornecedor" 
                                :valor="item.dc_valor" 
                                :adiantamento="true"
                                v-if="item && item.ch_tipo_lancamento == 'M'" />
                                
                        </template>

                        <div class="row mt-3 mb-3">
                            <div class="col col-12">
                                <az-sub-title v-if="false" class="mt-1" title="Classificação" />
                                <multiselect
                                    v-model="item.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    icon="fa-solid fa-barcode"
                                    sizing="sm"
                                    placeholder="Código de Barras..."
                                    :validate="validate"
                                    v-model="item.st_codigo_barra" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="textarea"
                                    rows="2"
                                    label="Observação"
                                    :validate="validate"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <template v-if="item.ch_estado == 'A' && item.usuario_receb">
                            <small class="text-muted">Recebido por {{ item.usuario_receb.pessoa.st_nome }}</small>
                        </template>

                        <!-- Campos Customizados -->

                        <div v-if="item.campos_customizados && item.campos_customizados.js_campos.length" class="row mt-3">
                            <div class="col col-12">
                                <az-sub-title :title="item.campos_customizados.st_titulo" />
                                <formulario 
                                    :gutters="true" 
                                    v-model="item.campos_customizados.js_campos" 
                                    :saved="true" 
                                    mode="fixed"
                                    :validate="validate"
                                    :config="true" />
                            </div>
                        </div>

                        <!-- Fim Campos Customizados -->

                    </div>

                    <div v-if="item && item.envio" class="mt-3">
                        <az-sub-title class="mt-1" title="Envio da Fatura">
                            {{ $util.getFormatDate(item.envio.dt_envio) }}
                        </az-sub-title>
                        <div v-if="!item.envio.creditos.length">
                            Nenhum crédito identificado.
                        </div>
                        <div v-else>
                            <ul class="list-group">
                                <li class="list-group-item">Saldo: {{ $util.formatMoeda(item.liquido) }}</li>
                                <li class="list-group-item d-flex justify-content-between" v-for="(cred, icx) in item.envio.creditos" :key="icx">
                                    <div>
                                        <div>#{{ cred.baixa.id_lancamento }}</div>
                                        <div class="small text-muted">{{ $util.getFormatDate(cred.dt_recebimento) }}</div>
                                    </div>
                                    <div class="text-right">
                                        <div>{{ $util.formatMoeda(cred.dc_valor) }}</div>
                                        <div class="small text-muted" v-if="cred.baixa && cred.baixa.conta">
                                            {{ cred.baixa.conta.search }}
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Notas Fiscais -->

                    <div v-if="item && item.nota_fiscal_links && item.nota_fiscal_links.length" class="mt-3">
                        <az-sub-title class="mt-1" title="Nota Fiscal"></az-sub-title>
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between" v-for="(nf, inx) in item.nota_fiscal_links" :key="inx">
                                <div>
                                    {{ nf.nota_fiscal_servico.search }}
                                </div>
                                <div class="text-right">
                                    {{ nf.nota_fiscal_servico.descricao_status }}
                                </div>
                            </li>
                        </ul>
                    </div>

                    <!-- Fechamentos / Recebimentos -->

                    <div v-if="item && item.fechamento_particular_items && item.fechamento_particular_items.length" class="mt-3">
                        <az-sub-title class="mt-1" title="Fechamentos / Recebimentos"></az-sub-title>
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between" v-for="(fechamento, ifx) in item.fechamento_particular_items" :key="ifx">
                                <div v-if="fechamento.fechamento">
                                    {{ $util.getFormatDate(fechamento.fechamento.created_at) }}
                                    {{ fechamento.fechamento.created_at.slice(11,16) }}
                                    <span class="ml-3">
                                        {{ fechamento.fechamento.usuario.st_login }}
                                    </span>
                                    <span class="badge badge-secondary ml-3" title="Id">
                                        #{{ fechamento.id_fechamento_particular }}
                                    </span>
                                    <span class="badge ml-3" :class="'badge-' + ( fechamento.fechamento.cor ? fechamento.fechamento.cor : 'dark' )" title="Tipo">
                                        {{ fechamento.fechamento.tipo }}
                                    </span>
                                </div>
                                <div>
                                    <span class="badge badge-secondary" v-if="fechamento.items_count > 0">
                                        {{ fechamento.items_count }}
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
                <div class="modal-footer" v-if="item">
                    <template v-if="solicitar_cancelar_lanc">
                        <div class="d-flex flex-column w-100 mb-0">
                            <az-input
                                type="text"
                                required
                                :validate="validate"
                                placeholder="Informe o motivo de cancelamento..."
                                v-model="item.st_motivo_cancelamento">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button class="btn btn-secondary" type="button" @click="solicitar_cancelar_lanc = false">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                        <button class="btn btn-danger" type="button" @click="remover ()">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                    </template>

                    <template v-else>
                        <az-audit-log-button model="lancamento" :id="item.id_lancamento" v-if="!viewonly" />
                        <button type="button" class="btn btn-primary" @click="abrir_ajuste_pag()" title="Ajustar Pagamento Particular." v-if="!viewonly && item.id_item_pagamento_atendimento && item.id_forma_pagamento == 2 && !item.baixa" 
                            data-toggle="tooltip" data-placement="top">
                            <i class="fa-solid fa-money-check-dollar-pen"></i>
                        </button>
                        <button type="button" class="btn btn-primary" @click="abrir_unecont()" title="UneCont" v-if="!viewonly && tem_unecont && item.ch_tipo_lancamento == 'D' && !item.baixa" data-toggle="tooltip" data-placement="top">
                            UneCont
                        </button>
                        <az-submit color="danger" @click="solicitar_cancelar_lanc = true" v-if="!viewonly && item.ch_estado != 'C' && item.ch_estado != 'R' && item.id_lancamento && ( !item.baixa || item.ch_tipo_lancamento == 'T' || item.ch_tipo_lancamento == 'M' )">Remover</az-submit>
                        <az-submit color="warning" @click="reprogramar ()" v-if="!viewonly && item.ch_estado == 'A' && item.ch_tipo_lancamento == 'D' && item.id_lancamento && !item.baixa">Reprogramar</az-submit>
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                        <az-submit @click="atualizar ()" v-if="!viewonly && item.ch_estado != 'C' && item.ch_estado != 'R' && pode_atualizar">{{ item.id_lancamento ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </template>
                </div>
                </div>
            </div>
        
        </div>

        <edicao-fornecedor ref="lanc_fornec" v-if="!blockaddfornecedor" />
        <ajuste-lancamento-cartao ref="ajustepag" @refresh="refresh_pag_partic" />
        <une-cont-vinc ref="unecontvinc" v-if="tem_unecont" @selecionar="vincular_une_cont"/>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from "moment";
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Multiselect from 'vue-multiselect';
import Impostos from './Impostos.vue';
import EdicaoFornecedor from './EdicaoFornecedor.vue';
import SaldoAdiantamento from './SaldoAdiantamento.vue';
import SelecaoCategoria from './SelecaoCategoria.vue';
import Formulario from '../consultorio/Formulario.vue';
import AjusteLancamentoCartao from './AjusteLancamentoCartao.vue';
import UneContVinc from './UneContVinc.vue';

export default {
    data () { 
        return { 
            item: null, 
            validate: false, 
            options_classes: [], 
            impostos: null, 
            abrindo: false,
            carregado: false, 
            movendo_centro: false, 
            trocando_valor_ad: false, 
            tipo_lista_categoria: 'L', 
            campos_customizados: false, 
            modelo_dist: null,
            centros_livres: false, 
            solicitar_cancelar_lanc: false, 
            tem_unecont: false, 
        }
    }, 

    components: { 
        AzSubTitle,
        AzSubmit,
        AzInput,
        AzEmptyState,
        AzAuditLogButton,
        Multiselect,
        Impostos,
        EdicaoFornecedor, 
        SaldoAdiantamento, 
        SelecaoCategoria, 
        Formulario,
        AjusteLancamentoCartao, 
        UneContVinc, 
    },

    props: ['unidade', 'fechamento', 'conta_ad', 'blockaddfornecedor', 'viewonly'],

    computed: { 
        total_parcelas: function () { 
            if ( !this.item || !this.item.vencimentos )
                return 0;

            return this.item.vencimentos.reduce((total, carry) => total + parseFloat(carry.valor), 0);
        },

        adiantamento_insuficiente() { 
            if ( this.item.id_lancamento ) 
                return false; 
            
            return ( Math.round(this.item.dc_valor_uso_adiantamento * 100) > Math.round(this.saldo_adiantamentos * 100) ); 
        },

        pode_atualizar_partic () { 
            return this.item.id_item_pagamento_atendimento ? false : true;
        },

        pode_atualizar () { 
            /*
            if ( this.item && ( this.item.id_item_pagamento_atendimento 
                || ( this.item.baixa && this.item.baixa.fatura_creditos && this.item.baixa.fatura_creditos.length ) ) ) { 
            */

            if ( this.item && ( this.item.baixa && this.item.baixa.fatura_creditos && this.item.baixa.fatura_creditos.length ) ) { 
                return false;
            }

            return true;
        },

        total_centros: function () { 
            return this.lista_centros_dist.reduce((total, centro) => { 
                return total + ( centro.dc_percentual ? Math.round(centro.dc_percentual * this.item.dc_valor) / 100 : centro.dc_valor );
            }, 0);
        },

        lista_centros_dist: function() { 
            if ( !this.item )
                return [];

            return this.item.centros.filter(item => !item.excluido);
        },
        
        lista_opcoes_lancamento: function () { 
            let lista = this.fechamento 
                    ? [{ id: 'C', search: 'Entrada' }, { id: 'D', search: 'Saída' }] 
                    : [{ id: 'C', search: 'Entrada' }, { id: 'D', search: 'Saída' }, { id: 'T', search: 'Transferência' }];

            if ( this.conta_ad ) { 
                lista.push({ id: 'M', search: 'Adiantamento' });
            }

            return lista;
        },

        saldo_adiantamentos: function () { 
            if ( !this.item || !this.item.fornecedor || !this.item.fornecedor.adiantamentos ) { 
                return 0;
            }

            return this.item.fornecedor.adiantamentos.reduce((total, item) => {
                return total + ( ( ( item.baixa && item.ch_tipo_lancamento == 'M' ) ? item.baixa.valor_liquido : ( item.baixa_adiantamento ? item.baixa_adiantamento.valor_liquido :  0 ) ) 
                    * ( item.ch_tipo_lancamento == 'D' ? -1 : 1 ) );
            }, 0);
        },

        lista_tipo_lanc: function () { 
            let lista = [
                { id: 'R', search: 'Realizado' },
            ];

            /*
            if ( this.conta_ad && this.item && this.item.ch_tipo_lancamento == 'D' ) { 
                lista.push({ id: 'A', search: 'Adiantado' });
            }
            */

            return lista;
        },

        lista_centros: function () { 
            
            if ( this.centros_livres && this.item.distribuir ) { 
                let lista = this.$store.state.unidade.unidade_operacaos.flatMap(item => { 
                    let ccs = _.cloneDeep(item.centro_custos);

                    ccs.forEach(cc => { 
                        cc.search = item.search + ' > ' + cc.st_nome;
                    });

                    return ccs;
                });

                lista = _.orderBy(lista, ['search'], ['asc']);

                return lista;
            }

            if ( !this.item.id_unidade_operacao ) 
                return [];

            let und = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.item.id_unidade_operacao);

            return und ? und.centro_custos : [];

        },

        total_retencoes: function () { 
            if ( !this.item || !this.item.retencoes )
                return 0;

            return this.item.retencoes.filter(item => item.fl_ativo)
                .reduce((total, carry) => { 
                    return total + carry.dc_valor;
                }, 0);
        },

        liquido: { 
            get: function () { 
                return this.item.dc_valor 
                    - this.item.desconto 
                    + this.item.multa 
                    - ( this.item.dc_descontos ? this.item.dc_descontos : 0 )
                    + ( this.item.dc_multa_juros ? this.item.dc_multa_juros : 0 )
                    - this.total_retencoes 
                    - this.item.dc_valor_uso_adiantamento;
            },

            set: function () { 
                //
            }
        },

        lista_impostos: function () { 
            if ( !this.impostos ) 
                return [];

            let lista = this.impostos.filter(imposto => this.item 
                && ( 
                    ( this.item.ch_tipo_lancamento == 'C' && imposto.fl_a_receber )
                    || ( this.item.ch_tipo_lancamento == 'D' && !imposto.fl_a_receber )
                )
            );

            return lista;
        },

        tem_valor_parcela: function () { 
            return this.item && this.item.recorrente && this.item.quantidade > 1 && this.item.tipo_valor == 'T';
        },
    },

    methods: { 
        trocar_forma(item) { 
            if ( item && item.item_pagamento_atendimento ) { 
                item.item_pagamento_atendimento.id_bandeira_cartao = ""; 
            }
        },
        
        vincular_une_cont (nfex) { 
            this.item.id_nota_fiscal_externa = nfex.id_nota_fiscal_externa;
            this.item.nf_externa = nfex;
            this.item.st_doc = nfex.st_numero_nf;
            this.item.dt_emissao = nfex.dt_emissao;
        },

        abrir_unecont () { 
            this.$refs.unecontvinc.abrir(this.item);
        },

        refresh_pag_partic() { 
            this.$emit('refresh');
        },

        abrir_ajuste_pag () { 
            this.$refs.ajustepag.abrir(this.item);
        },

        remover_adiantamento () { 
            if ( !confirm('Confirma remover o adiantamento do lançamento?') )
                return;

            this.$util.atualizar (this, { 
                service: 'financeiro',
                func: 'remover_adiantamento',
                dados: { 
                    id_lancamento: this.item.id_lancamento,
                },
                modal: 'lancamentoModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        reprogramar () { 
            if ( !confirm('Reprogramar o Lançamento?') )
                return;

            this.item.id_lancamento_origem = this.item.id_lancamento;
            this.item.tipo_valor = 'T';
            this.item.id_lancamento = null; 
        },

        aplicar_modelo () { 
            if ( !this.modelo_dist ) { 
                return;
            }

            console.log('modelo', this.modelo_dist);

            if ( this.modelo_dist.items ) { 

                if ( this.item.centros && this.item.centros.length == 1 && this.item.centros[0].id_centro_custo == "" ) { 
                    this.remover_centro(this.item.centros[0]);
                }

                this.modelo_dist.items.forEach(element => {
                    this.incluir_centro(element);
                });

            }

            this.modelo_dist = null;

            this.$nextTick(() => { 
                this.modelo_dist = "";
            });

        },

        fechar() { 
            $('#lancamentoModal').modal('hide');
        },

        totalizar (lista, campo) { 
            return lista.reduce((total, carry) => { 
                return total + parseFloat(carry[campo]);
            }, 0);
        },

        recalc_parcelas(item) { 
            console.log('Recalcular Parcelas', item);
        },

        definir_vencimentos(item) { 
            let base = item.dt_vencimento;
        
            // this.$set(item.vencimentos, []);

            item.vencimentos = [];

            this.$set(item.vencimentos, 0, { 
                data: base,
                valor: item.quantidade ? Math.round(100 * ( item.dc_valor / item.quantidade)) / 100 : 0, 
                impostos: { retencoes: [] }, 
            });

            if ( item.quantidade > 1 ) { 

                for (let index = 1; index < item.quantidade; index++) {
                    this.$set(item.vencimentos, index, { 
                        data: moment(base).add(index, 'M').format('YYYY-MM-DD'),
                        valor: item.quantidade ? Math.round(100 * ( item.dc_valor / item.quantidade)) / 100 : 0,  
                        impostos: { retencoes: [] }, 
                    });
                }

                let soma = item.vencimentos.reduce((total, carry) => total + carry.valor, 0);

                item.vencimentos[item.vencimentos.length - 1].valor = item.vencimentos[item.vencimentos.length - 1].valor + ( item.dc_valor - soma );

            }

            item.vencs = !item.vencs;

            this.$forceUpdate();
        },

        titulo_distribuir() {
            let titulo = "";

            if ( this.item.distribuir ) 
                titulo = 'Centros de Custo';

            if ( this.item.distribuir_categ ) { 
                titulo = ( titulo ? titulo + ' / ' : '' ) + 'Categoria';
            }

            return titulo;
        },

        alterar_tipo_lista() { 
            this.item.id_categoria = "";
            this.tipo_lista_categoria = ( this.tipo_lista_categoria == 'L' ? 'B' : 'L' );
            this.$util.setCookie('tipo_lista_categoria', this.tipo_lista_categoria);
        },

        alterar_tipo_lista_item (item) { 
            item.id_categoria = ""; 
            item.busca_lista = !item.busca_lista;
            this.$forceUpdate();
        },

        utilizar_ad (valor) { 
            this.trocando_valor_ad = true;

            this.$nextTick(() => { 
                this.item.dc_valor_uso_adiantamento = valor;
                this.trocando_valor_ad = false;
            });
        },

        refresh_impostos() { 
            this.item.id_fornecedor = "";
            this.item.id_operadora = "";
            this.item.id_categoria = "";
            this.item.fornecedor = "";

            if ( this.$refs.impostos ) { 
                this.$nextTick(() => { 
                    if ( this.$refs.impostos ) {
                        this.$refs.impostos.refresh_lista(this.lista_impostos);
                    }
                });
            }
        },

        incluir_fornecedor() { 
            if ( !confirm('Incluir Fornecedor?') )
                return;

            // $('.modal').modal('hide');
            this.$refs.lanc_fornec.incluir();
        },

        remover_centro (centro) { 
            this.movendo_centro = true;
            centro.excluido = true;

            this.$nextTick(() => { 
                this.movendo_centro = false;
            });
        },

        incluir_centro (modelo = null) { 
            this.item.centros.push({
                id_lancamento_centro_custo: null, 
                id_lancamento: this.item.id_lancamento, 
                id_centro_custo: modelo ? modelo.id_centro_custo : "", 
                id_categoria: "", 
                dc_valor: 0,
                dc_percentual: modelo ? modelo.dc_percentual : 0, 
                st_observacao: "", 
                excluido: false, 
                busca_lista: false, 
            });
        },

        cancelar_distribuir () { 
            this.item.centros = null;
            this.item.distribuir = false
            this.item.distribuir_categ = false;
        },

        distribuir () { 
            $('[data-toggle="tooltip"]').tooltip('dispose');

            this.item.centros = [];
            this.item.distribuir = true
            this.item.id_centro_custo = null;

            if ( !this.item.centros.length )
                this.incluir_centro();
        },

        distribuir_categ() { 

            $('[data-toggle="tooltip"]').tooltip('dispose');

            if ( !this.item.centros ) { 
                this.item.centros = [];
            }
            
            this.item.distribuir_categ = true
            this.item.id_categoria = null;

            if ( !this.item.centros.length )
                this.incluir_centro();
        },

        incluir_impostos () { 
            if ( this.abrindo )
                return;

            if ( this.item.ch_tipo_lancamento == 'D' && !this.item.distribuir && this.item.fornecedor && this.item.fornecedor.id_categoria ) { 
                this.item.id_categoria = this.item.fornecedor.id_categoria;
            }

            if ( this.item.ch_tipo_lancamento == 'D' && !this.item.distribuir && this.item.fornecedor && this.item.fornecedor.centro ) { 
                this.item.id_unidade_operacao = this.item.fornecedor.centro.id_unidade_operacao;
                this.item.id_centro_custo = this.item.fornecedor.centro.id_centro_custo;
            }

            if ( this.item.ch_tipo_lancamento == 'D' && this.$refs.impostos ) { 
                this.$refs.impostos.incluir_do_fornecedor(this.item.fornecedor);
            }
        },

        recalcular_impostos() { 
            if ( this.abrindo || ( this.item && this.item.ch_tipo_lancamento == 'M' ) )
                return;

            this.$nextTick(() => { 
                if ( this.$refs.impostos )
                    this.$refs.impostos.recalcular();
            });
        },

        registrar_baixa (item, selec = null) { 
            this.$parent.registrar_baixa(item, selec);
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
            this.item.nova_classe = true;
        },

        remover () { 

            /*
            if ( !confirm ('Confirma excluir esse lançamento?') )
                return;
            */

            this.$util.atualizar (this, { 
                service: 'financeiro',
                func: 'destroy',
                dados: { 
                    lancamentos: [
                            { 
                               id_lancamento: this.item.id_lancamento, 
                               st_motivo_cancelamento: this.item.st_motivo_cancelamento
                            }, 
                        ]
                },
                modal: 'lancamentoModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });

        },

        atualizar () { 
            let dados = _.cloneDeep(this.item);
            dados.dt_competencia = dados.dt_competencia.substr (0,7);

            if ( !dados.id_lancamento && dados.tipo_lanc == 'A' ) { 
                dados.tipo_lanc = 'R';
                dados.id_conta_baixa = this.conta_ad.id_conta;
                dados.recorrente = false;
            }

            if ( this.liquido < 0 ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Valor líquido não pode ser negativo.",
                    life: 3000
                });
                return;
            } else if ( this.adiantamento_insuficiente ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Saldo adiantado insuficiente. " 
                        + '\n Saldo: ' + this.$util.formatMoeda(this.saldo_adiantamentos)
                        + '\n Uso: ' + this.$util.formatMoeda(this.item ? this.item.dc_valor_uso_adiantamento : 0)
                        + '\n Líquido: ' + this.$util.formatMoeda(this.liquido),
                    life: 3000
                });
                return;
            }

            if ( this.item.distribuir ) { 
                if ( Math.round(this.item.dc_valor * 100) != Math.round(this.total_centros * 100) ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Valor distribuído dos centros de custo divergente: " + this.total_centros 
                            + " vs " + this.item.dc_valor,
                        life: 3000
                    });
                    return;
                }
            }

            this.$util.atualizar (this, { 
                service: 'financeiro',
                dados: dados, 
                modal: 'lancamentoModal', 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        editar (item) { 
            this.solicitar_cancelar_lanc = false;
            this.abrindo = true;
            this.item = null; 
            this.validate = false;
            this.carregado = true;

            this.$nextTick(() => {
                $('#lancamentoModal').modal('show');
 
                this.$util.load(this, { 
                    service: 'financeiro',
                    func: 'show',
                    parms: { 
                        id: item.id_lancamento, 
                    },
                    loadTo: res => { 
                        this.item = res;

                        this.$nextTick(() => { 
                            this.abrindo = false;
                        });
                    }
                });
            });
        },

        incluir (realizado = false, conta = null, valores_default = null, tipo = "D") { 
            this.abrindo = true;
            this.solicitar_cancelar_lanc = false;

            let item = { 
                id_lancamento: null, 
                id_categoria: null, 
                id_forma_pagamento: null, 
                dc_valor: 0, 
                dc_valor_uso_adiantamento: 0, 
                dc_multa_juros: 0, 
                dc_descontos: 0, 
                dt_competencia: this.$util.hoje(), 
                dt_emissao: this.$util.hoje(), 
                dt_vencimento: this.$util.hoje(), 
                st_descricao: null, 
                ch_tipo_lancamento: tipo,
                ch_estado: 'A',
                fornecedor: "", 
                recorrente: false, 
                recorrente_emissao_fixa: true,
                quantidade: 12, 
                vencs: false,
                vencimentos: [],
                competencia_fixa: false, 
                tipo_valor: 'P',
                tipo_lanc: realizado ? 'R' : "",
                id_conta_baixa: conta ? conta : "", 
                id_conta_origem: conta ? conta : "", 
                id_conta_destino: "",
                id_unidade_operacao: ( this.unidade && !isNaN(this.unidade) ) 
                    ? this.unidade 
                    : ( this.$store.state.unidade.unidade_operacaos.length == 1 
                        ? this.$store.state.unidade.unidade_operacaos[0].id_unidade_operacao
                        : '' ), 
                st_doc: "", 
                id_centro_custo: "", 
                js_classes: [], 
                desconto: 0,
                multa: 0, 
                retencoes: [], 
                distribuir: false, 
                distribuir_categ: false, 
                centros: [], 
                id_operadora: "", 
                sel_form: 'C', 
                campos_customizados: null, 
                id_lancamento_origem: null, 
                ad_previsto: false, 
            };

            if ( valores_default ) { 
                item = _.merge(item, valores_default);
            }

            this.item = null; 
            this.validate = false;
            this.carregado = true;

            this.$nextTick(() => { 
                this.item = item;
                $('#lancamentoModal').modal('show');

                if ( this.campos_customizados === false ) { 
                    this.$util.loadItem(this, { 
                        service: 'financeiro',
                        func: 'novo',
                    })
                    .then(res => { 
                        if ( res ) { 
                            this.campos_customizados = res.campos_customizados;
                        } else { 
                            this.campos_customizados = null;
                        }

                        this.item.campos_customizados = _.cloneDeep(this.campos_customizados);
                        this.centros_livres = res.centros_livres ? true : false; 
                    });
                } else { 
                    this.item.campos_customizados = _.cloneDeep(this.campos_customizados);
                }

                this.$nextTick(() => { 
                    this.abrindo = false;

                    if ( this.item.fornecedor ) { 
                        this.incluir_impostos();
                    }
                });
            });
        },

    },

    updated() { 
        $('[data-toggle="tooltip"]').tooltip();
    },

    mounted () { 

        this.tipo_lista_categoria = this.$util.getCookie('tipo_lista_categoria') 
            ? this.$util.getCookie('tipo_lista_categoria') 
            : 'L';

        if ( this.$store.state.contexto && this.$store.state.contexto.lanc_tags ) { 

            this.options_classes = this.$store.state.contexto.lanc_tags;

        } else { 

            this.$util.loadItem(this, { 
                service: 'lancamentos',
                func: 'tags',
                configs: [
                    'unecont-login'
                ]
            })
            .then(res => { 
                this.options_classes = res;

                if ( this.$store.state.contexto['unecont-login'] ) { 
                    this.tem_unecont = true; 
                }

                this.$store.commit('setContexto', { lanc_tags: res });
            });

        }

        if ( this.$store.state.contexto && this.$store.state.contexto.lanc_impostos ) { 

            this.impostos = this.$store.state.contexto.lanc_impostos;

        } else { 

            this.$util.loadItem(this, { 
                service: 'impostos',
                func: 'index',
                parms: { 
                    where: { 
                        fl_ativo: true,
                    },
                },
            })
            .then(res => { 
                this.impostos = res;

                this.$store.commit('setContexto', { lanc_impostos: res });
            });

        }

    }

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>